//路由配置
export default {
  mode: 'history',
  base: '/actives/courses/',
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        needLogin: false,
        navbarHide: false,
        keepAlive:true

      },
      component: () => import('@/views/client/Home'),
    },
    {
      path: '/entry',
      name: 'entry',
      meta: {
        needLogin: false,
        navbarHide: true,
      },
      component: () => import('@/views/client/entry'),
    },
    {
      path: '/inquiry/index',
      name: 'inquiry',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/inquiry/index'),
    },
    {
      path: '/bases/list',
      name: 'basesList',
      meta: {
        needLogin: false,
        keepAlive:true
      },
      component: () => import('@/views/client/bases/list'),
    },
    {
      path: '/bases/details',
      name: 'basesDetails',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/bases/details'),
    },
    {
      path: '/article/lesson/index',
      name: 'lessonIndex',
      meta: {
        needLogin: false,
        keepAlive:true
      },
      component: () => import('@/views/client/article/lesson/index'),
    },
    {
      path: '/article/lesson/details',
      name: 'lessonList',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/article/lesson/details'),
    },
    {
      path: '/article/lesson/drawer',
      name: 'lessonDrawer',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/article/lesson/drawer'),
    },
    {
      path: '/article/lesson/schools',
      name: 'lessonSchools',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/article/lesson/schools'),
    },
    {
      path: '/article/news/index',
      name: 'newsIndex',
      meta: {
        needLogin: false,
        keepAlive: true // 需要被缓存
      },
      component: () => import('@/views/client/article/news/index'),
    },
    {
      path: '/article/news/details',
      name: 'newsDetails',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/article/news/details'),
    },
    {
      path: '/article/news/drawer',
      name: 'newsDrawer',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/article/news/drawer'),
    },
    {
      path: '/article/actives/list',
      name: 'activesList',
      meta: {
        needLogin: false,
        keepAlive:true
      },
      component: () => import('@/views/client/article/actives/list'),
    },
    {
      path: '/venue/species',
      name: 'venueSpecies',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/venue/species'),
    },
    {
      path: '/venue/list',
      name: 'venueList',
      meta: {
        needLogin: false,
        keepAlive:true
      },
      component: () => import('@/views/client/venue/list'),
    },
    {
      path: '/venue/details',
      name: 'venueDetails',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/venue/details'),
    },
    {
      path: '/venue/drawer',
      name: 'venueDrawer',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/venue/drawer'),
    },
    {
      path: '/venue/alllist',
      name: 'venueAlllist',
      meta: {
        needLogin: false,
        keepAlive:true,
        forbidShare:true
      },
      component: () => import('@/views/client/venue/alllist'),
    },
    {
      path: '/personal/index',
      name: 'personalIndex',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/personal/index'),
    },
    {
      path: '/personal/notice',
      name: 'personalNotice',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/personal/notice'),
    },
    {
      path: '/personal/message',
      name: 'personalMessage',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/personal/message'),
    },
    {
      path: '/personal/userinfo',
      name: 'personalUserinfo',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/personal/userinfo'),
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        needLogin: false,
        navbarHide: true,
      },
      component: () => import('@/views/client/login'),
    },
    {
      path: '/personal/collect',
      name: 'personalCollect',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/personal/collect'),
    },
    {
      path: '/map/baidu',
      name: 'mapBaidu',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/map/baidu'),
    },
    {
      path: '/personal/like',
      name: 'personalLike',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/personal/like'),
    },
    {
      path: '/order/schedule',
      name: 'orderSchedule',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/order/schedule'),
    },
    {
      path: '/order/info',
      name: 'orderInfo',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/order/info'),
    },
    {
      path: '/order/adinfo',
      name: 'orderAdinfo',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/order/adinfo'),
    },
    {
      path: '/order/list',
      name: 'orderList',
      meta: {
        needLogin: false,
        keepAlive:true
      },
      component: () => import('@/views/client/order/list'),
    },
    {
      path: '/order/admin',
      name: 'orderAdmin',
      meta: {
        needLogin: false,
        keepAlive:true
      },
      component: () => import('@/views/client/order/admin'),
    },
    {
      path: '/order/ordertice',
      name: 'orderOrdertice',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/client/order/ordertice'),
    },
    {
      path: '/^(!/client)*/',
      name: '404',
      meta: {
        needLogin: false,
      },
      component: () => import('@/views/NotFound'),
    },
  ],
  scrollBehavior(to, from, savePosition) {
    console.log(to,savePosition,888777)
    if(savePosition){
      return savePosition
    }else{
      return {
        y: 0,
      }
    }
    
  }
}
